import { isEqual, filter, orderBy } from 'lodash';
import MyAccountActionType from '../../common/MyAccountActionType';
import LoginSessionHandler from '../../common/LoginSessionHandler';

const defaultCustomerInfo = {
  accountBalance: 0,
  connected: false,
  currentCardLastDigits: '',
  emailAddress: '',
  firstName: '',
  lastName: '',
  mobileNumber: '',
  zuoraAccountId: '',
  ufbUpgradeAvailable: false,
  changeSuccess: false
};

const clearedState = {
  loggedIn: false,
  loginError: false,
  customerInfo: defaultCustomerInfo,
  updatePaymentSuccess: false,
  payNowSuccess: false,
  payNowError: '',
  resetPasswordSuccess: false,
  changeSuccess: false,
  availablePlans: []
};

const initialState = {
  loggedIn: LoginSessionHandler.isLoggedIn() || false,
  loginError: false,
  customerInfo: LoginSessionHandler.getCustomerInfo() || defaultCustomerInfo,
  updatePaymentSuccess: false,
  payNowSuccess: false,
  payNowError: '',
  resetPasswordSuccess: false,
  changeSuccess: false,
  availablePlans: LoginSessionHandler.getAvailablePlans() || []
};

const MyAccountReducer = (state = initialState, action) => {
  switch (action.type) {
    case MyAccountActionType.SET_LOG_IN: {
      return Object.assign({}, state, { loggedIn: action.loggedIn });
    }
    case MyAccountActionType.STORE_CUSTOMER_INFO: {
      LoginSessionHandler.setCustomerInfo(action.customerInfo);
      return Object.assign({}, state, { customerInfo: action.customerInfo });
    }
    case MyAccountActionType.STORE_PAY_NOW_ERROR: {
      return Object.assign({}, state, { payNowError: action.payNowError });
    }
    case MyAccountActionType.RESET_ALL: {
      LoginSessionHandler.clear();
      return clearedState;
    }
    case MyAccountActionType.STORE_UPDATE_PAYMENT_SUCCESS: {
      return Object.assign({}, state, { updatePaymentSuccess: true });
    }
    case MyAccountActionType.STORE_PAY_NOW_SUCCESS: {
      return Object.assign({}, state, { payNowSuccess: true });
    }
    case MyAccountActionType.STORE_RESET_PASSWORD_SUCCESS: {
      return Object.assign({}, state, { resetPasswordSuccess: true });
    }
    case MyAccountActionType.CLEAR_ALL_DASHBOARD_NOTIFICATIONS: {
      return Object.assign({}, state, {
        updatePaymentSuccess: false,
        payNowSuccess: false,
        errors: {},
        payNowError: '',
        resetPasswordSuccess: false,
        changeSuccess: false
      });
    }
    case MyAccountActionType.SET_MOVE_TO_PLAN: {
      return Object.assign({}, state, { moveToPlan: action.label });
    }
    case MyAccountActionType.STORE_AVAILABLE_PLANS: {
      LoginSessionHandler.setAvailablePlans(action.plans);
      return { ...state, availablePlans: action.plans };
    }
    default:
      return state;
  }
};

const isContractEqual = isContract => plan => isEqual(plan.isContract, isContract);

// filter plans by contract type and order by price
const filterPlans = (plans, isContract) => {
  const filteredPlans = filter(plans, isContractEqual(isContract));
  return orderBy(filteredPlans, 'price');
};


export const MyAccountSelector = {
  getCustomerInfo: state => state.myAccount.customerInfo,
  getAvailablePlans: state => filterPlans(state.myAccount.availablePlans, state.myAccount.customerInfo.contract)
};

export default MyAccountReducer;



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/MyAccountReducer.js
 **/